import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

// キャンペーンに応じてデフォルトの言語を選ぶようにするhook
// i18nのライブラリが`i18nextLng`というキーでローカルストレージに保存するようになっている。
// callbackで`{campaign-name}_i18nextLng`というキーでローカルストレージに追加で保存するようにもしている。
// そのため、APIなどの実行に利用されるのは、`{campaign-name}_i18nextLng`だが、実際の切り替えに寄与しているのは`i18nextLng`であることに注意
export const useChangeLanguage = ({ campaign }: { campaign: Api.CampaignResBody }) => {
  const { i18n } = useTranslation()

  useEffect(() => {
    if (campaign && campaign.type) {
      if (campaign.isLocalize && campaign.languages.length > 1) {
        // 多言語化対応している場合
        const i18nextLng = localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`)
        if (!i18nextLng) {
          // キャンペーンに応じた多言語の設定がない場合には日本語に設定
          localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`, 'ja_JP')
          i18n.changeLanguage('ja_JP')
        } else {
          // キャンペーンに応じた多言語の設定がある場合には、そのまま設定
          i18n.changeLanguage(i18nextLng)
        }
      } else {
        // 多言語化対応していない場合
        // 強制的に日本語に設定する
        localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`, 'ja_JP')
        i18n.changeLanguage('ja_JP')
      }
    }
  }, [campaign])
}
